"use client";

import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
function TestimonialsConsumer() {
  const {
    posts,
    loading
  } = usePosts();
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (!posts || posts.length === 0 || loading) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % posts.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [posts, loading]);
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {[...Array(3)].map((_, i) => <div key={i} className="aspect-[4/5] w-full rounded-xl bg-muted animate-pulse" />)}
      </div>;
  }
  if (!posts || posts.length === 0) {
    return null;
  }
  const nextSlide = () => setCurrentIndex(prev => (prev + 1) % posts.length);
  const prevSlide = () => setCurrentIndex(prev => (prev - 1 + posts.length) % posts.length);
  return <div className="relative w-full group">
      {}
      <div className="overflow-hidden">
        <div className="flex transition-transform duration-500 ease-out" style={{
        transform: `translateX(-${currentIndex * (100 / (typeof window !== 'undefined' && window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1))}%)`
      }}>
          {posts.map((post, i) => <div key={post.id} data-index={i} className="w-full md:w-1/2 lg:w-1/3 flex-shrink-0 px-4">
              <Card className="border-2 border-transparent shadow-md h-full transition-all duration-300 hover:border-secondary hover:-translate-y-2 p-8 flex flex-col items-center text-center bg-card rounded-2xl">
                {}
                <div className="w-20 h-20 rounded-full overflow-hidden mb-6 border-2 border-accent shrink-0">
                  <img src={post.customFields?.image || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/placeholder_avatar.png"} alt={post.customFields?.author || post.title} className="w-full h-full object-cover" loading="lazy" />
                </div>

                {}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, starIdx) => <Star key={starIdx} className={`w-4 h-4 ${starIdx < (Number(post.customFields?.rating) || 5) ? "fill-primary text-primary" : "text-muted"}`} />)}
                </div>

                {}
                <blockquote className="flex-grow mb-6">
                  <p className="text-muted-foreground italic font-light leading-relaxed relative">
                    <span className="text-4xl text-primary/20 absolute -top-4 -left-2 font-serif">"</span>
                    {post.customFields?.quote}
                    <span className="text-4xl text-primary/20 absolute -bottom-8 right-0 font-serif">"</span>
                  </p>
                </blockquote>

                {}
                <div className="mt-auto">
                  <h4 className="font-serif text-xl text-secondary font-medium">
                    {post.customFields?.author || post.title}
                  </h4>
                  <p className="text-sm text-primary font-medium uppercase tracking-wider mt-1">
                    {post.customFields?.city}
                  </p>
                </div>
              </Card>
            </div>)}
        </div>
      </div>

      {}
      <div className="absolute top-1/2 -translate-y-1/2 -left-4 lg:-left-12 z-20">
        <Button variant="ghost" size="icon" onClick={prevSlide} className="rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 hover:-translate-x-1 transition-transform">
          <ChevronLeft className="w-6 h-6" />
        </Button>
      </div>
      <div className="absolute top-1/2 -translate-y-1/2 -right-4 lg:-right-12 z-20">
        <Button variant="ghost" size="icon" onClick={nextSlide} className="rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 hover:translate-x-1 transition-transform">
          <ChevronRight className="w-6 h-6" />
        </Button>
      </div>

      {}
      <div className="flex justify-center gap-2 mt-12">
        {posts.map((_, i) => <Button key={i} variant="ghost" size="sm" onClick={() => setCurrentIndex(i)} className={`p-0 h-2 min-w-0 transition-all duration-300 rounded-full hover:bg-transparent ${currentIndex === i ? "w-8 bg-secondary" : "w-2 bg-secondary/30"}`} aria-label={`Go to slide ${i + 1}`} />)}
      </div>
    </div>;
}
export default function TravelerTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const wp_query_params = {
    post_type: "card",
    per_page: 6,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}